import * as Types from 'actions/types';

export default function (state=null,action){
    switch(action.type){
        case Types.SHOW_NOTIFICATION:
            return {...action.payload};
        case Types.DISMISS_NOTIFICATION:
            return null;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/notifications.js